var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    className: "loading_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 85.333q42.667 0 42.667 42.667v128q0 42.667-42.667 42.667T469.333 256V128q0-42.667 42.667-42.667",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 725.333q42.667 0 42.667 42.667v128q0 42.667-42.667 42.667T469.333 896V768q0-42.667 42.667-42.667",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M938.667 512q0 42.667-42.667 42.667H768q-42.667 0-42.667-42.667T768 469.333h128q42.667 0 42.667 42.667",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.667 512q0 42.667-42.667 42.667H128q-42.667 0-42.667-42.667T128 469.333h128q42.667 0 42.667 42.667",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M813.7 210.309q30.17 30.17 0 60.34l-90.51 90.509q-30.169 30.17-60.339 0t0-60.34l90.51-90.51q30.17-30.17 60.34 0z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M361.135 662.831q30.17 30.17 0 60.34l-90.51 90.51q-30.17 30.17-60.34 0t0-60.34l90.51-90.51q30.17-30.17 60.34 0",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M813.691 813.7q-30.17 30.17-60.34 0l-90.509-90.51q-30.17-30.169 0-60.339t60.34 0l90.51 90.51q30.17 30.17 0 60.34z",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361.169 361.135q-30.17 30.17-60.34 0l-90.51-90.51q-30.17-30.17 0-60.34t60.34 0l90.51 90.51q30.17 30.17 0 60.34",
    opacity: 0.7
  })));
};
export default SvgLoading;